import { createGlobalStyle } from 'styled-components';
import { theme } from '@grays-npm/component-library';

export const GlobalStyle = createGlobalStyle`
  :root {
    font-size: 16px;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  #modal-root {
    position: relative;
    z-index: 999;
  }

  body, div {
    box-sizing: border-box;
    font-family: ${theme.fonts.roboto};
  }

  body {
    color: ${theme.colors.primary.graysGray};
    font-family: Roboto;
    margin: 0;
  }
`;
